'use client'

import isPropValid from '@emotion/is-prop-valid'
import styled from '@emotion/styled'
import type { ImageProps } from 'next/image'
import { mq } from 'ui/src/theme/media'
import { tokens } from 'ui/src/theme/tokens.css'
import { ImageWithPlaceholder } from '@/components/ImageWithPlaceholder/ImageWithPlaceholder'

export type ImageAspectRatio = '1 / 1' | '2 / 1' | '3 / 2' | '4 / 3' | '5 / 4' | '16 / 9'

type WrapperProps = {
  aspectRatioLandscape?: ImageAspectRatio
  aspectRatioPortrait?: ImageAspectRatio
}

export const ImageWrapper = styled('div', { shouldForwardProp: isPropValid })<WrapperProps>(
  ({ aspectRatioLandscape = '3 / 2', aspectRatioPortrait = '3 / 2' }) => ({
    position: 'relative',
    ['@media (orientation: landscape)']: {
      aspectRatio: aspectRatioLandscape,
    },
    ['@media (orientation: portrait)']: {
      aspectRatio: aspectRatioPortrait,
    },
  }),
)

type ExtraImageProps = {
  roundedCorners: boolean
} & ImageProps

export const StyledImage = styled(ImageWithPlaceholder, {
  shouldForwardProp: (prop) => (prop === 'priority' ? true : isPropValid(prop)),
})<ExtraImageProps>(({ roundedCorners }) => ({
  objectFit: 'cover',
  ...(roundedCorners && {
    borderRadius: tokens.radius.md,
    [mq.lg]: {
      borderRadius: tokens.radius.xl,
    },
  }),
}))

export const BodyWrapper = styled.div({
  position: 'absolute',
  top: tokens.space.md,
  left: tokens.space.md,
  right: tokens.space.md,
})
